export default __webpack_public_path__ + "static/media/fish.ef9752ef.jpg";